import React from "react";
import { SHARE_PAGINATION_PREVIOUS, SHARE_PAGINATION_NEXT } from "./shareCopy";
import "./sharepage.css";

// Pagination bar for the share-recipient table. Rendered OUTSIDE the bordered
// table card: "Showing X to Y of Z results" on the left, the page nav on the
// right (‹ Previous · [n] · Next ›), matching the Figma.
const SharePagination = ({
  page = 1,
  limit = 10,
  totalUsers = 0,
  handlePageChange = () => {},
}) => {
  if (!totalUsers) {
    return null;
  }

  const totalPages = Math.ceil(totalUsers / limit);
  const currentPage = page;
  const startPage = Math.max(2, currentPage - 2);
  const endPage = Math.min(totalPages - 1, currentPage + 2);

  const pages = [];
  for (let i = startPage; i <= endPage; i++) {
    pages.push(
      <li key={i} className={`page-item share_pagination_num ${currentPage === i ? "active" : ""}`}>
        <button className="page-link mx-1" onClick={() => handlePageChange(i)}>
          {i}
        </button>
      </li>
    );
  }

  return (
    <div className="share_pagination_bar">
      <small className="share_pagination_count">
        Showing&nbsp; <b>{(page - 1) * limit + 1}</b> &nbsp;to&nbsp;
        <b>{Math.min(page * limit, totalUsers)}</b>&nbsp; of &nbsp;
        <b>{totalUsers}</b> &nbsp;results
      </small>
      <nav>
        <ul className="pagination mb-0">
          <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
            <button
              className="page-link mx-1 share_pagination_nav"
              onClick={() => handlePageChange(page - 1)}
            >
              &lsaquo; {SHARE_PAGINATION_PREVIOUS}
            </button>
          </li>
          <li className={`page-item share_pagination_num ${page === 1 ? "active" : ""}`}>
            <button className="page-link mx-1" onClick={() => handlePageChange(1)}>
              1
            </button>
          </li>
          {currentPage > 4 && (
            <li className="page-item disabled share_pagination_num">
              <span className="page-link mx-1">…</span>
            </li>
          )}
          {pages}
          {currentPage < totalPages - 3 && (
            <li className="page-item disabled share_pagination_num">
              <span className="page-link mx-1">…</span>
            </li>
          )}
          {totalPages > 1 && (
            <li
              className={`page-item share_pagination_num ${
                currentPage === totalPages ? "active" : ""
              }`}
            >
              <button
                className="page-link mx-1"
                onClick={() => handlePageChange(totalPages)}
              >
                {totalPages}
              </button>
            </li>
          )}
          <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
            <button
              className="page-link mx-1 share_pagination_nav"
              onClick={() => handlePageChange(page + 1)}
            >
              {SHARE_PAGINATION_NEXT} &rsaquo;
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default SharePagination;
